import React, {PureComponent} from 'react';
import PropTypes from 'prop-types';

import {ControllerContainer} from '@stubhub/react-store-provider';

import controllerFactory from './controller';

import DeliveryInfo from './index';

class DeliveryInfoContainer extends PureComponent {
  render() {
    const childProps = {...this.props};

    return <ControllerContainer factory={controllerFactory} component={DeliveryInfo} {...childProps} />;
  }
}

DeliveryInfoContainer.propTypes = {
  /**
   * The namespace for this Event Filter Component instance.
   * NOTE -  This is used to isolate the Store for multiple instance of the same component.
   *
   */
  namespace: PropTypes.string.isRequired,
};

export default DeliveryInfoContainer;
